import React from 'react'
import * as constants from '../../../../../static/constants'
import styled from 'styled-components'
import { ISelectedDate } from 'utils/reservation'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  selectedDates: ISelectedDate
  guestCount: number
  setIsOpenDatePicker: React.Dispatch<React.SetStateAction<boolean>>
  setIsOpenGuestCount: React.Dispatch<React.SetStateAction<boolean>>
}

export const ReservationDateGuest: React.VFC<IProps> = ({
  selectedDates,
  guestCount,
  setIsOpenDatePicker,
  setIsOpenGuestCount,
}) => {
  const dateLabel = React.useMemo(() => {
    if (selectedDates.startDate && selectedDates.endDate) {
      return `${selectedDates.startDate.format('MMM DD')} - ${selectedDates.endDate.format(
        'MMM DD'
      )}`
    }
    return 'ADD DATE'
  }, [selectedDates])

  const toggleDatePicker = () => {
    setIsOpenDatePicker(old => !old)
    setIsOpenGuestCount(false)
  }

  const toggleGuestCount = () => {
    setIsOpenGuestCount(old => !old)
    setIsOpenDatePicker(false)
  }

  return (
    <DateGuest>
      <div className="Date">
        <SvgIcon className="date-people-icon" name="calender" />
        <div className="pulldown" onClick={toggleDatePicker}>
          <p className="label">DATES</p>
          <p className="value">
            {dateLabel} <SvgIcon name="keyboard_arrow_down" width={24} height={24} />
          </p>
        </div>
      </div>
      <div className="Guests">
        <SvgIcon className="date-people-icon" name="person_filled" />
        <div className="pulldown" onClick={toggleGuestCount}>
          <p className="label">GUESTS</p>
          <p className="value">
            <span>
              <b>{guestCount}</b>Guests
            </span>
            <SvgIcon name="keyboard_arrow_down" width={24} height={24} />
          </p>
        </div>
      </div>
    </DateGuest>
  )
}

const DateGuest = styled.div`
  display: flex;
  align-items: center;
  width: 480px;
  padding: 1.6rem 0;
  border: 1px solid ${constants.COLORS.primary};
  box-shadow: ${constants.COLORS.cardShadow};
  border-radius: 1.6rem;
  width: 100%;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    width: 100%;
    padding: 0.4rem 0;
  }
  .PostShow_StickyBox_content & {
    width: 100%;
    padding: 1.2rem 0;
    border-color: ${constants.COLORS.divider};
    box-shadow: none;
    border-radius: 0.8rem;
  }
  > div {
    display: inline-flex;
    align-items: center;
    width: 100%;
    padding: 0 1.6rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      height: auto;
      padding: 0.8rem 1.6rem;
    }
    .pulldown {
      cursor: pointer;
      flex: 1;
      width: 100%;
      margin-left: 1.6rem;
      .PostShow_StickyBox_content & {
        margin-left: 0;
      }
      &:hover .value {
        color: ${constants.COLORS.primary};
      }
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        margin-left: 0;
      }
      .label {
        line-height: 2rem;
        font-size: 1.3rem;
        font-weight: bold;
        margin-bottom: 0.8rem;
        @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
          margin-bottom: 0;
          font-size: 1.2rem;
        }
        .PostShow_StickyBox_content & {
          line-height: 1.6rem;
          font-size: 1.2rem;
          margin-bottom: 0.4rem;
        }
      }
      .value {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 1.6rem;
        white-space: nowrap;
        transition: color 0.2s;
        span b {
          font-weight: bold;
          margin-right: 0.4rem;
        }
        @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
          font-size: 1.4rem;
        }
      }
    }
  }
  .Date {
    border-right: 1px solid ${constants.COLORS.divider};
  }
  .date-people-icon {
    flex: none;
    padding: 10px;
    width: 44px;
    height: 44px;
    border-radius: 22px;
    color: ${constants.COLORS.primary};
    background-color: ${constants.COLORS.successBG};
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      display: none;
    }
    .PostShow_StickyBox_content & {
      display: none;
    }
  }
`
